import { fromJS } from "immutable"
import { validate } from "../../../utils/functions"
import { KEY_ISOLATED_METRICS, setItem } from "../../../utils/storage"
import {
  GET_STATUS_WATCHER,
  GET_STATUS_SUCCESS,
  GET_STATUS_FAILED,
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_MEASURE_COLOR_RANGE_FAILED,
  SAVE_CONFIG_BENCHMARK_WATCHER,
  SAVE_CONFIG_BENCHMARK_SUCCESS,
  SAVE_CONFIG_BENCHMARK_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoading: false,
  isLoadingTotal: false,
  no_process: false,
  measureColorRange: [],
  isMeasureProcess: false,
  divisionsAvailable: [],
  divisionsData: {},
  measureGeneral: null,
  measureTotal: null,
  measureConfig: null,
  isLoadingSaveConfig: false,
  isSectorDataAvailable: false,
  companySectors: [],
  companySectorsGlobal: [],
  companySector: null,
  userType: null,
  isErrorStatus: false,
})

function reportAdminReducer(state = initialState, action) {
  switch (action.type) {
    // Dentro de la MISMA medición (cambio de división/segmento) no reseteamos
    // measureGeneral/measureTotal para no desmontar los widgets (VLENG-4961).
    // Si cambia la medición sí: si no, los widgets usan datos de la anterior (VLENG-12055).
    case GET_STATUS_WATCHER: {
      setItem(KEY_ISOLATED_METRICS, false)
      const currentMeasure = state.get("measureGeneral")
      const isOtherMeasure =
        !currentMeasure || currentMeasure.id_measure !== action.payload.id_measure
      const loadingState = state.set("isLoading", true).set("isErrorStatus", false)
      return isOtherMeasure
        ? loadingState.set("measureGeneral", null).set("measureTotal", null)
        : loadingState
    }

    case GET_STATUS_SUCCESS:
      setItem(
        KEY_ISOLATED_METRICS,
        action.payload.measureGeneral.has_isolated_metrics || false
      )
      return state
        .set("isLoading", false)
        .set(
          "isMeasureProcess",
          !!(action.payload.measureTotal && action.payload.measureTotal.percent)
        )
        .set("divisionsAvailable", action.payload.divisionsAvailable)
        .set("divisionsData", action.payload.divisionsData)
        .set("measureTotal", action.payload.measureTotal)
        .set("measureGeneral", action.payload.measureGeneral)
        .set("isErrorStatus", false)
        .set("userType", action.payload.userType)
        .set("measureConfig", action.payload.measureConfig)
        .set("isSectorDataAvailable", action.payload.isSectorDataAvailable)
        .set("companySectors", action.payload.companySectors)
        .set("companySectorsGlobal", action.payload.companySectorsGlobal)
        .set("companySector", action.payload.companySector)

    case GET_STATUS_FAILED:
      return state
        .set("isLoading", false)
        .set("isMeasureProcess", false)
        .set("isErrorStatus", true)

    case GET_MEASURE_COLOR_RANGE_WATCHER:
      return state
    case GET_MEASURE_COLOR_RANGE_SUCCESS:
      return state.set(
        "measureColorRange",
        validate.exist(action.payload.report_color_range)
          ? action.payload.report_color_range
          : []
      )
    case GET_MEASURE_COLOR_RANGE_FAILED:
      return state.set("measureColorRange", [])

    case SAVE_CONFIG_BENCHMARK_WATCHER:
      return state.set("isLoadingSaveConfig", true)
    case SAVE_CONFIG_BENCHMARK_SUCCESS:
      return state.set("isLoadingSaveConfig", false)
    case SAVE_CONFIG_BENCHMARK_FAILED:
      return state.set("isLoadingSaveConfig", false)

    default:
      return state
  }
}

export default reportAdminReducer
